<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { TYPES, globalEchCodeCollection } from '@/models/EchCode';
import type { Ref } from 'vue';

const value: Ref<any> = defineModel();

const props = defineProps<{
    type: typeof TYPES[keyof typeof TYPES];
    label?: string;
}>();

const codes = globalEchCodeCollection(props.type);
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="codes.getModels()"
        :option-label="(v: any) => $t(v.i18n_key) + ' (' + v.code + ')'"
        option-value="id"
    ></KpSelectField>
</template>
